/**
 * DrewCore Universal AJAX Form Handler.
 *
 * Automatikusan kezeli az összes .drewcore-form osztályú űrlapot.
 * A form_type hidden input határozza meg a form típust.
 *
 * Használat HTML-ben:
 *   <form class="drewcore-form" data-form-type="kapcsolat">
 *     <input type="hidden" name="form_type" value="kapcsolat">
 *     <input type="hidden" name="lead_forras_oldal" value="<?php echo esc_url(...); ?>">
 *     <?php drewcore_form_spam_fields(); ?>  <!-- KÖTELEZŐ! honeypot + időbélyeg;
 *          enélkül a szerver MINDEN beküldést "Érvénytelen kérés" hibával dob el -->
 *     <input type="text" name="lead_nev" required>
 *     <input type="email" name="lead_email" required>
 *     <input type="tel" name="lead_telefon">
 *     <textarea name="lead_uzenet"></textarea>
 *     <input type="checkbox" name="lead_adatvedelem" value="1" required>
 *     <button type="submit">Küldés</button>
 *   </form>
 *   <div class="drewcore-form-message" data-for="kapcsolat"></div>
 *
 * A form-handler.php által wp_localize_script-tel injektált drewcoreForm objektumot használja:
 *   drewcoreForm.url    -- admin-ajax.php URL
 *   drewcoreForm.action -- 'drewcore_form_submit'
 *   drewcoreForm.nonces -- { kapcsolat: '...', arajanlat: '...', stb. } (csak FALLBACK!)
 *
 * Nonce stratégia: beküldés előtt FRISS nonce-t kérünk a
 * ?action=drewcore_form_nonce végpontról. A HTML-be sütött nonce oldal-cache
 * mellett 12-24 óra után lejár, és minden látogató beküldése elhalna --
 * az admin-ajax válaszát viszont a page cache-ek nem cache-elik.
 */

(function () {
  'use strict';

  if (typeof drewcoreForm === 'undefined') return;

  var forms = document.querySelectorAll('.drewcore-form');
  if (!forms.length) return;

  for (var i = 0; i < forms.length; i++) {
    attachFormHandler(forms[i]);
  }

  /**
   * Friss nonce lekérése; hibánál a localize-olt (cache-elt) nonce a fallback.
   */
  function fetchFreshNonce(formType, done) {
    var fallback = drewcoreForm.nonces[formType] || '';
    var sep = drewcoreForm.url.indexOf('?') === -1 ? '?' : '&';
    var url = drewcoreForm.url + sep +
      'action=drewcore_form_nonce&form_type=' + encodeURIComponent(formType) +
      '&_=' + Date.now();

    var xhr = new XMLHttpRequest();
    xhr.open('GET', url, true);
    xhr.onload = function () {
      // A done() szigorúan egyszer hívódik, a try-n KÍVÜL -- ha a done()
      // (= beküldés) dobna, a catch nem indíthat második beküldést.
      var nonce = fallback;
      try {
        var resp = JSON.parse(xhr.responseText);
        if (resp.success && resp.data && resp.data.nonce) {
          nonce = resp.data.nonce;
        }
      } catch (err) { /* marad a fallback */ }
      done(nonce);
    };
    xhr.onerror = function () {
      done(fallback);
    };
    xhr.send();
  }

  function attachFormHandler(form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var formType = form.getAttribute('data-form-type') || 'kapcsolat';
      var submitBtn = form.querySelector('[type="submit"]');

      // A message elemet a FORMHOZ KÉPEST keressük: két azonos típusú űrlapnál
      // a data-for alapú globális keresés mindig az ELSŐ form dobozát találná meg.
      var msgEl = form.parentElement ? form.parentElement.querySelector('.drewcore-form-message') : null;
      if (!msgEl) {
        msgEl = document.querySelector('.drewcore-form-message[data-for="' + formType + '"]');
      }

      if (!submitBtn) return;

      // Disable button
      var originalText = submitBtn.textContent;
      submitBtn.disabled = true;
      submitBtn.textContent = 'Küldés...';

      // Clear previous messages
      if (msgEl) {
        msgEl.textContent = '';
        msgEl.className = 'drewcore-form-message';
      }

      // Friss nonce, majd beküldés
      fetchFreshNonce(formType, function (nonce) {
        sendForm(nonce);
      });

      function sendForm(nonce) {

      // Build FormData
      var formData = new FormData(form);
      formData.append('action', drewcoreForm.action);
      formData.append('nonce', nonce);

      // AJAX request
      var xhr = new XMLHttpRequest();
      xhr.open('POST', drewcoreForm.url, true);

      xhr.onload = function () {
        submitBtn.disabled = false;
        submitBtn.textContent = originalText;

        var response;
        try {
          response = JSON.parse(xhr.responseText);
        } catch (err) {
          showMessage(msgEl, 'Hiba történt. Próbálja újra.', 'error');
          return;
        }

        if (response.success) {
          showMessage(msgEl, response.data.message || 'Köszönjük!', 'success');
          form.reset();

          // Redirect if provided
          if (response.data.redirect) {
            setTimeout(function () {
              window.location.href = response.data.redirect;
            }, 1500);
          }
        } else {
          var errorMsg = (response.data && response.data.message) ? response.data.message : 'Hiba történt.';
          showMessage(msgEl, errorMsg, 'error');
        }
      };

      xhr.onerror = function () {
        submitBtn.disabled = false;
        submitBtn.textContent = originalText;
        showMessage(msgEl, 'Hálózati hiba. Ellenőrizze az internetkapcsolatot.', 'error');
      };

      xhr.send(formData);
      } // sendForm vége
    });
  }

  function showMessage(el, text, type) {
    if (!el) return;
    el.textContent = text;
    el.className = 'drewcore-form-message drewcore-form-message--' + type;

    if (type === 'error') {
      el.classList.add('text-danger');
    } else {
      el.classList.add('text-success');
    }
  }
})();
